import React, { useEffect, useState } from 'react'
import { track } from '@vercel/analytics'
import { loadDetailText } from '../utils/poiDataLoader.js'

// Must stay in sync with SEC_Markers.jsx, UI.jsx
const SEC_SUBSECTIONS = {
  SEC006: { parent: 'SEC001' }
}

export default function SEC_Window({ secData, onClose, isClosing = false, closeDirection = 'bottom' }) {
  const [sectionDetailText, setSectionDetailText] = useState(null)

  useEffect(() => {
    if (!secData?.section) return
    loadDetailText().then(({ sectionMap }) => {
      setSectionDetailText(sectionMap.get(secData.section) || null)
    })
  }, [secData?.section])

  if (!secData) return null

  const isSubSection = Boolean(SEC_SUBSECTIONS[secData.id])

  const popupClass = isClosing
    ? (closeDirection === 'bottom' ? 'window hide-bottom' : 'window hide')
    : 'window show'

  const handleBackClick = () => {
    track('sec_popup_back_clicked', { section: secData.section })
    if (isSubSection) {
      window.dispatchEvent(new CustomEvent('sec-subsection-back', {
        detail: { fromSec: secData.id, returnToSec: SEC_SUBSECTIONS[secData.id].parent }
      }))
      return
    }
    onClose()
  }

  return (
    <div className={popupClass}>
      <div className="heading">{secData.section || 'Section'}</div>

      {sectionDetailText && (
        <div className="poi-product-detail poi-category-detail">
          <p>{sectionDetailText}</p>
        </div>
      )}

      <div className="buttonRow">
        <div className="backButton" onClick={handleBackClick}>BACK</div>
      </div>
    </div>
  )
}
